export interface ProjectType {
  projectTypeId?: string;
  code?: string;
  displayName?: string;
  operationType?: string;
  operationTypeDisplayName?: string;
}

export function compare(pt1: ProjectType, pt2: ProjectType) {
  if (pt1 && pt2) {
    if (pt1.projectTypeId && pt2.projectTypeId) {
      return pt1.projectTypeId === pt2.projectTypeId;
    }
    return pt1.code === pt2.code;
  }
  return false;
}
